module.exports = __webpack_public_path__ + "img/interstitial_logo_people.5948d72e.png";